<script>
    import { createEventDispatcher } from 'svelte'
    import Action from './Action.svelte'

    import { steps, cards } from '../../logic'
    import { step, backlog, week } from '../../stores'

    let items = []

    const dispatch = createEventDispatcher()

    $:{
        items = $backlog
        .map((cardId) => {
            const findCard = cards.find((card) => card.id === cardId)
            const disabled = !steps[$step].next?.map((n) => steps[n]?.cardId).includes(cardId) ?? false
            //debugger
            return {
                ...findCard,
                disabled
            }
        })
        .filter((item) => !item.disabled )
        // .sort((a, b) => {
        //     if (a.disabled && !b.disabled){ return 1 }
        //     if (!a.disabled && -b.disabled){ return -1 }
        //     return 0
        // })
    }

    const handleAddActionToDay = ({ detail }) => {
        week.update((state) => {
            const { items, currentDay } = state

            return {
                    ...state,
                    items: {
                        ...items,
                        [currentDay]: [ ...(typeof items[currentDay] === 'undefined' ? [] : items[currentDay]),  { ...detail }]
                    }
            }
        })

        dispatch('reaction', detail.id)

        const nextStepKey = steps[$step].next?.find((n) => steps[n].cardId === detail.id) ?? null

        if (nextStepKey){
            step.set(nextStepKey)
        }
    }
</script>

<div class="wrapper">
    <div class="title">Возможные действия</div>

    <div class="actions-wrapper">
        {#each items as item (item.id)}
            <Action 
                data={item} 
                disabled={item.disabled}
                on:addtoday={handleAddActionToDay} 
            />
        {/each}
    </div>
</div>

<style lang="scss" module>
    .wrapper {
        margin-top: 36px;

        .title {
            font-weight: 700;
            font-size: 18px;
            line-height: 23px;
            color: #343B45;
        }

        .actions-wrapper {
            display: flex;
            flex-wrap: wrap;
            margin: 33px 15px 0 15px;
        }
    }

    @media (max-width: 720px) {
        .wrapper {
            margin-top: 12px;
            
            .actions-wrapper {
                margin: 0;
                margin-top: 24px;
                justify-content: space-between;
            }
        }
    }
</style>